import { render, staticRenderFns } from "./member_send.vue?vue&type=template&id=65fb43a7&scoped=true"
import script from "./member_send.vue?vue&type=script&lang=js"
export * from "./member_send.vue?vue&type=script&lang=js"
import style0 from "./member_send.vue?vue&type=style&index=0&id=65fb43a7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65fb43a7",
  null
  
)

export default component.exports